import { render, staticRenderFns } from "./RosterPage.vue?vue&type=template&id=50da2d3f&scoped=true&"
import script from "./RosterPage.vue?vue&type=script&lang=js&"
export * from "./RosterPage.vue?vue&type=script&lang=js&"
import style0 from "./RosterPage.vue?vue&type=style&index=0&id=50da2d3f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50da2d3f",
  null
  
)

export default component.exports